import React, { Component } from "react";
import propertiesStyle from "./Properties.module.css";
import styles from "./AutoFollow.module.css";
import TriangleDown from "../../SVG/TriangleDown";
import TriangleRight from "../../SVG/TriangleRight";
import { setProperty as SET_PROPERTY } from "../../Scripts/PropertyUtils";
import DragInput from "../DragInput/DragInput";

export default class AutoFollow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colorClicked: false,
      open: false,
    };
  }

  updateProperty(property, value) {
    SET_PROPERTY(this.props.item, property, value);
    this.setState({ update: true });
  }

  colorClicked(e) {
    this.setState({
      colorClicked: !this.state.colorClicked,
    });
  }

  handleMouseDown(e, property, startValue) {
    this.property = property;
    this.mouseDown = true;
    var rect = document.querySelector("body").getBoundingClientRect();
    var x = e.clientX - rect.left; //x position within the element.
    this.startX = x;

    this.startValue = startValue;
    document.addEventListener("mousemove", this.handleMouseMove.bind(this));
    document.addEventListener("mouseup", this.handleMouseUp.bind(this));
  }

  handleMouseMove(e) {
    if (this.mouseDown) {
      var rect = document.querySelector("body").getBoundingClientRect();
      var x = e.clientX - rect.left; //x position within the element.
      x = x - this.startX;

      this.updateProperty(this.property, this.startValue + x);
    }
  }

  handleMouseUp(e) {
    this.mouseDown = false;
    document.removeEventListener("mousemove", this.handleMouseMove.bind(this));
    document.removeEventListener("mouseup", this.handleMouseUp.bind(this));
  }

  applyAutoFollow(item) {
    if (this.props.item.autoFollow) {
      this.props.item.autoFollow = null;
      return;
    }
    if (!this.props.item.autoFollowPadding) {
      this.props.item.autoFollowPadding = 50;
    }
    this.props.item.autoFollow = item;
    try {
      let func = new Function(
         "hyperAPI",
        "currentItem",
        `
          let window = '';
   
           function update() {
         
            if (currentItem.autoFollow) {
              const followItem = currentItem.autoFollow;
              if (currentItem.autoFollowMode === 'directional') {
                const axis = currentItem.autoFollowAlignment === 'y' ? 'y' : 'x';
                const posProp = \`position.\${axis}\`;
                const sizeProp = axis === 'y' ? '_height' : '_width';
                const sizePropAlt = axis === 'y' ? 'height' : 'width';
                const isTextVisible = followItem.type === 'TEXT' && followItem.text !== '' && followItem.visible;
                const isTextHidden = followItem.type === 'TEXT' && (followItem.text === '' || !followItem.visible);
                const size = isTextVisible ? followItem[sizeProp] : followItem[sizePropAlt];
                const padding = isTextHidden ? 0 : currentItem.autoFollowPadding;
                let offset = 0;
                switch (currentItem.autoFollowDirection) {
                  case 'left':
                    offset = -size - padding;
                    break;
                  case 'centre':
                    offset = size / 2 + padding;
                    break;
                  case 'centrel':
                    offset = -size / 2 - padding;
                    break;
                  default: // right
                    offset = size + padding;
                    break;
                }
                hyperAPI.setProperty(currentItem, posProp, parseInt(followItem.position[axis]) + offset);
              } else {
                if (followItem.type === 'TEXT') {
                  if (followItem.text !== '' && followItem.visible === true) {
                    hyperAPI.setProperty(currentItem, 'position.x', parseInt(followItem.position.x) + parseInt(followItem._width) + parseInt(currentItem.autoFollowPadding));
                  } else {
                    hyperAPI.setProperty(currentItem, 'position.x', parseInt(followItem.position.x) + parseInt(followItem._width));
                  }
                } else {
                  hyperAPI.setProperty(currentItem, 'position.x', parseInt(followItem.position.x) + parseInt(followItem.width) + parseInt(currentItem.autoFollowPadding));
                }
              }
            }
          }
            return {
              update: update
            };
          `
      )(window.hyperAPI, this.props.item);

      this.props.item.autofollowCode = func;
    } catch (err) {}
  }

  renderChild(children) {
    return children.map((item) => {
      return (
        <div>
          <div
            onClick={() => this.applyAutoFollow(item)}
            className={`${styles.Item} ${
              item === this.props.item.autoFollow ? styles.Active : ""
            }`}
          >
            {item.name}
          </div>
          {this.renderChild(item.children)}
        </div>
      );
    });
  }

  render() {
    return (
      <div className={propertiesStyle.Group}>
        <div
          className={propertiesStyle.GroupTitle}
          onClick={() => this.setState({ open: !this.state.open })}
        >
          <div className={propertiesStyle.Open}>
            {this.state.open && <TriangleDown />}
            {!this.state.open && <TriangleRight />}
          </div>
          <div className={propertiesStyle.Title}>Auto Follow</div>
        </div>
        {this.state.open && (
          <div className={styles.Group}>
            <div className={styles.Property}>
              <label
                className={styles.Y}
                draggable={true}
                onDragStart={(event) =>
                  this.drag(
                    event,
                    "autoFollowPadding",
                    this.props.item.autoFollowPadding
                  )
                }
              >
                Padding
              </label>
              <DragInput
                value={this.props.item.autoFollowPadding}
                onChange={(value) => {
                  this.updateProperty("autoFollowPadding", value);
                }}
              />
            </div>
            {this.props.item.autoFollow && (
              <div className={styles.Property}>
                <label className={styles.CheckboxContainer}>
                  Directional Mode
                  <input
                    type="checkbox"
                    checked={this.props.item.autoFollowMode === "directional"}
                    onChange={(e) => {
                      this.updateProperty(
                        "autoFollowMode",
                        e.target.checked ? "directional" : "legacy"
                      );
                    }}
                  />
                  <span className={styles.Checkmark} />
                </label>
              </div>
            )}
            {this.props.item.autoFollow &&
              this.props.item.autoFollowMode === "directional" && (
            <>
             <label>Follow Axis</label>
            <div style={{display: "flex", flexDirection: "row",}}>
              <label className={styles.CheckboxContainer}>
                X
                <input
                  type="radio"
                  name="autofollowalignment"
                  id="x"
                  value="x"
                  checked={this.props.item.autoFollowAlignment === "x"}
                  onChange={() => {
                    this.updateProperty("autoFollowAlignment", "x");
                  }}
                />
                <span className={styles.Checkmark} />
                </label>
                <label className={styles.CheckboxContainer}>
                Y
                <input
                  type="radio"
                  name="autofollowalignment"
                  id="y"
                  value="y"
                  checked={this.props.item.autoFollowAlignment === "y"}
                  onChange={() => {
                    this.updateProperty("autoFollowAlignment", "y");
                  }}
                />
                <span className={styles.Checkmark} />
                </label>
                </div>
            <label>Follow Direction</label>
            <div style={{display: "flex", flexDirection: "row",}}>
              <label className={styles.CheckboxContainer}>
                {this.props.item.autoFollowAlignment === "y" ? "Top" : "Left"}
                <input
                  type="radio"
                  name="autofollowdirection"
                  id="left"
                  value="left"
                  checked={this.props.item.autoFollowDirection === "left"}
                  onChange={() => {
                    this.updateProperty("autoFollowDirection", "left");
                  }}
                />
                <span className={styles.Checkmark} />
                </label>
              <label className={styles.CheckboxContainer}>
                {this.props.item.autoFollowAlignment === "y" ? "Centre Top" : "Centre Left"}
                <input
                  type="radio"
                  name="autofollowdirection"
                  id="centrel"
                  value="centrel"
                  checked={this.props.item.autoFollowDirection === "centrel"}
                  onChange={() => {
                    this.updateProperty("autoFollowDirection", "centrel");
                  }}
                />
                <span className={styles.Checkmark} />
              </label>
              <label className={styles.CheckboxContainer}>
                {this.props.item.autoFollowAlignment === "y" ? "Centre Bottom" : "Centre Right"}
                <input
                  type="radio"
                  name="autofollowdirection"
                  id="centre"
                  value="centre"
                  checked={this.props.item.autoFollowDirection === "centre"}
                  onChange={() => {
                    this.updateProperty("autoFollowDirection", "centre");
                  }}
                />
                <span className={styles.Checkmark} />
              </label>
              <label className={styles.CheckboxContainer}>
            {this.props.item.autoFollowAlignment === "y" ? "Bottom" : "Right"}
                <input
                  type="radio"
                  name="autofollowdirection"
                  id="right"
                  value="right"
                  checked={this.props.item.autoFollowDirection === "right"}
                  onChange={() => {
                    this.updateProperty("autoFollowDirection", "right");
                  }}
                />
                <span className={styles.Checkmark} />
                </label>
            
            </div>
            </>
            )}
            <div className={styles.lists}>
              <div className={styles.Property}>
                {this.renderChild(this.props.scene.children)}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}


